import { render } from "./LesColloquesPage.vue?vue&type=template&id=7fde88aa"
import script from "./LesColloquesPage.vue?vue&type=script&lang=js"
export * from "./LesColloquesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__